export const Slides = [
    {id:1,src: "/photos/product-1.webp",alt: "producto 1"},
    {id:2,src: "/photos/product-2.webp",alt: "producto 2"},
    {id:3,src: "/photos/product-3.webp",alt: "producto 3"},
    {id:4,src: "/photos/product-4.webp",alt: "producto 4"},
    {id:5,src: "/photos/product-5.webp",alt: "producto 5"},
    {id:6,src: "/photos/product-6.webp",alt: "producto 6"},
    {id:7,src: "/photos/product-7.webp",alt: "producto 7"},
    {id:8,src: "/photos/product-8.webp",alt: "producto 8"}
]